export default {
  en: {
    // English text from TDS Community `Modal`
    closeButton: 'Close'
  },
  fr: {
    closeButton: 'Fermer'
  }
};